/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit UpperSection/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import DateSelector from './DateSelector/index'
import EmergencyAppointmentAction from './EmergencyAppointmentAction/index'
import NewAppointmentAction from './NewAppointmentAction/index'
import React from 'react'
import SidebarExpandAction from './SidebarExpandAction/index'
import TodayAction from './TodayAction/index'
import styles from './view.module.css'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function UpperSection({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/Calendar/Content/Content/Topbar/UpperSection"
  
}) {
  let isMedia = useIsMedia()
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="UpperSection.Horizontal"
  data-view-path={viewPath}
 style={{'--pl-1-RqAq6': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pr-2-RqAq6': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--bbc-3-RqAq6': dtColorsNeutral200,'--fw-5-RqAq6': isMedia.mobile ? "wrap" : "nowrap",'--h-4-RqAq6': isMedia.mobile ? "auto" : "48px"}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="UpperSection.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-6-RqAq6': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-7-RqAq6': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pb-8-RqAq6': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Horizontal1}`}
>
<SidebarExpandAction
  viewPath={`${viewPath}/SidebarExpandAction`}
/>
<DateSelector
  viewPath={`${viewPath}/DateSelector`}
/>
<TodayAction
  viewPath={`${viewPath}/TodayAction`}
/>
</div>
<div
  data-testid="UpperSection.Horizontal:2"
  data-view-path={viewPath}
 style={{'--g-6-RqAq6': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-7-RqAq6': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pb-8-RqAq6': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--ml-9-RqAq6': isMedia.mobile ? "0px" : "auto"}}
 className={`views-block ${styles.Horizontal2}`}
>
<NewAppointmentAction
  viewPath={`${viewPath}/NewAppointmentAction`}
/>
<EmergencyAppointmentAction
  viewPath={`${viewPath}/EmergencyAppointmentAction`}
/>
</div>
</div>
{children}
</React.Fragment>)
}